import React from "react";
import { useFormState } from "react-hook-form";
export const SubscriptionFormSubmitButton = ({ ...rest }) => {
  const { isValid, isSubmitting, submitCount } = useFormState();
  return (
    <div className="text-center w-full">
      <button type="submit" {...rest} title={isValid?"Start Subscription" : "Form is missing data"} disabled={!isValid || isSubmitting} className={`${isValid &&! isSubmitting?"text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" : "cursor-not-allowed text-gray-500 bg-indigo-100" } mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm`  }>Start Subscription</button>
    </div>
  );
};
